import { CustomAxiosRequestConfig } from "../interceptors/axios/custom-axios";
import { BaseApi } from "./base-api";

/**
 * Generic API call utility for POST requests.
 * @param endpoint 
 * @param payload  
 * @returns        
 */
export const commonPostServiceApi = async <T = any, P = any>(endpoint: string, payload: P = {} as P): Promise<T> => {
    try {
        const response = await BaseApi.baseApiCon.post(endpoint, payload);
        return response.data?.data ?? response.data;
    } catch (error: any) {
        throw new Error(error?.response?.data?.errorMessage||error?.response?.data?.detail|| error?.response?.data?.errorDescription);
    }
};
export const commonPostServiceApiCSRF = async <T = any, P = any>(endpoint: string, payload: P = {} as P): Promise<T> => {
    try {
        const response = await BaseApi.baseApiCon.post(endpoint, payload,{ requiresCSRF: true } as CustomAxiosRequestConfig);
        return response.data?.data ?? response.data;
    } catch (error: any) {
        throw new Error(error?.response?.data?.errorMessage||error?.response?.data?.detail|| error?.response?.data?.errorDescription);
    }
};